const prismWords = {
    "abdomen": [
        "stomach",
        "tummy",
        "belly"
    ],
    "abrasion": [
        "scrape",
        "scratch"
    ],
    "absorb": [
        "take in fluids",
        "soak up"
    ],
    "abstain from": [
        "don't",
        "don't use",
        "don't have",
        "go without"
    ],
    "accompany": [
        "go (along) with",
        "come with"
    ],
    "accomplish": [
        "carry out",
        "do"
    ],
    "accordingly": [
        "so",
        "for that reason",
        "as a result"
    ],
    "accrue": [
        "add",
        "gain",
        "build up"
    ],
    "accumulate": [
        "add",
        "build up",
        "collect",
        "gather"
    ],
    "accurate": [
        "correct",
        "exact",
        "right"
    ],
    "acquire": [
        "get"
    ],
    "activate": [
        "begin",
        "start"
    ],
    "acute": [
        "sudden",
        "new",
        "recent",
        "intense flare-up",
        "serious pain",
        "short-term"
    ],
    "addictive": [
        "habit-forming"
    ],
    "additional": [
        "added",
        "extra",
        "more",
        "other"
    ],
    "address": [
        "talk about",
        "discuss"
    ],
    "adequate": [
        "enough"
    ],
    "adjacent": [
        "next to",
        "by"
    ],
    "administer": [
        "give"
    ],
    "advantageous": [
        "helpful",
        "useful"
    ],
    "adverse": [
        "harmful",
        "bad"
    ],
    "adversely impact": [
        "hurt",
        "set back"
    ],
    "affirmative": [
        "yes",
        "positive"
    ],
    "aggravate": [
        "make worse"
    ],
    "aggregate": [
        "all together",
        "added together",
        "combined"
    ],
    "agitation": [
        "anxiety",
        "restlessness",
        "nervousness"
    ],
    "ailment": [
        "sickness",
        "illness",
        "health problem",
        "complaint"
    ],
    "allergen": [
        "something that causes allergies"
    ],
    "allergic rhinitis": [
        "hay fever"
    ],
    "alleviate": [
        "ease",
        "decrease",
        "lessen"
    ],
    "allocate": [
        "divide",
        "give based on a plan"
    ],
    "allow": [
        "let"
    ],
    "alopecia": [
        "hair loss"
    ],
    "alternative": [
        "choice",
        "option"
    ],
    "ameliorate": [
        "improve",
        "get better",
        "make better",
        "improve"
    ],
    "ambulate": [
        "walk"
    ],
    "ambulatory": [
        "able to walk"
    ],
    "amend": [
        "change"
    ],
    "analgesic": [
        "pain killer",
        "pain reliever"
    ],
    "analyze": [
        "look at",
        "study",
        "examine"
    ],
    "anaphylaxis": [
        "shock or serious allergic reaction"
    ],
    "anesthetic (general)": [
        "a drug that puts you to sleep"
    ],
    "anesthetic (local)": [
        "a drug that numbs an area of your body"
    ],
    "angina (or angina pectoris)": [
        "chest pain"
    ],
    "anterior": [
        "front"
    ],
    "anticipate": [
        "expect"
    ],
    "anticoagulant": [
        "blood thinner"
    ],
    "anti-inflammatory": [
        "helps swelling go down"
    ],
    "apparent": [
        "clear",
        "plain",
        "show up"
    ],
    "appreciate": [
        "thankful",
        "thanks"
    ],
    "appreciation": [
        "thankful",
        "thanks"
    ],
    "apprise": [
        "inform",
        "tell"
    ],
    "appropriate": [
        "correct",
        "proper",
        "right"
    ],
    "appropriately": [
        "correctly",
        "properly"
    ],
    "approximate": [
        "about",
        "around",
        "roughly"
    ],
    "approximately": [
        "about",
        "around",
        "roughly"
    ],
    "arrhythmia": [
        "irregular heartbeat",
        "when the heart doesn't have a steady beat"
    ],
    "arteriosclerosis": [
        "hardening of the arteries"
    ],
    "atherosclerosis": [
        "hardening of the arteries"
    ],
    "articulate": [
        "say",
        "state",
        "tell"
    ],
    "ascertain": [
        "find out",
        "learn"
    ],
    "ascorbic acid": [
        "vitamin C"
    ],
    "asphyxiate": [
        "choke (ing)",
        "suffocate (tion)"
    ],
    "asphyxiation": [
        "choke (ing)",
        "suffocate (tion)"
    ],
    "aspirate": [
        "fluid in the lungs"
    ],
    "aspiration": [
        "fluid in the lungs"
    ],
    "assay": [
        "lab test"
    ],
    "assess": [
        "learn about",
        "study"
    ],
    "assessment": [
        "review",
        "quiz",
        "rating",
        "report",
        "test",
        "interview"
    ],
    "assist": [
        "help",
        "aid"
    ],
    "assistance": [
        "help",
        "aid"
    ],
    "associated": [
        "linked to",
        "related to"
    ],
    "asymptomatic": [
        "without symptoms"
    ],
    "atopic dermatitis": [
        "itchy red rash"
    ],
    "attain": [
        "meet a goal",
        "get"
    ],
    "attempt": [
        "try"
    ],
    "audit": [
        "review",
        "inspect",
        "look at"
    ],
    "aural": [
        "hearing"
    ],
    "bacteria": [
        "germs"
    ],
    "beneficial": [
        "helpful",
        "good"
    ],
    "benefit": [
        "good effect",
        "advantage",
        "help",
        "be useful to"
    ],
    "benign": [
        "isn't harmful",
        "not cancer"
    ],
    "bilateral": [
        "on both sides"
    ],
    "biopsy": [
        "sample of tissue from part of the body"
    ],
    "blood glucose": [
        "blood sugar"
    ],
    "blood profile": [
        "series of blood tests"
    ],
    "BMI": [
        "using your height and weight to measure if you're overweight"
    ],
    "body mass index": [
        "using your height and weight to measure if you're overweight"
    ],
    "bradycardia": [
        "slow heart beat"
    ],
    "buttocks": [
        "butt",
        "backside",
        "rear",
        "rear end"
    ],
    "calculate": [
        "add up",
        "figure out"
    ],
    "capable": [
        "able",
        "ability"
    ],
    "capability": [
        "able",
        "ability"
    ],
    "carcinogen": [
        "something that can cause cancer"
    ],
    "carcinoma": [
        "cancer"
    ],
    "cardiac": [
        "(of/in/related to) the heart"
    ],
    "cardiologist": [
        "heart doctor"
    ],
    "cardiovascular": [
        "heart and/or blood vessel"
    ],
    "carpal": [
        "wrist"
    ],
    "category": [
        "kind",
        "class",
        "group"
    ],
    "catheter": [
        "a tube for (putting fluids into/ taking fluids out of) the body"
    ],
    "catheterize": [
        "put a tube into (part of the body)"
    ],
    "caveat": [
        "warning",
        "detail to think about"
    ],
    "cease": [
        "stop"
    ],
    "cell culture": [
        "tissue sample or a study of the tissue"
    ],
    "cellulitis": [
        "skin infection"
    ],
    "Central Nervous System (CNS)": [
        "brain and spinal cord"
    ],
    "cerebral hemorrhage (or cerebral accident or cerebrovascular accident or CVA)": [
        "stroke",
        "blood clot in the brain"
    ],
    "cessation": [
        "ending",
        "stop",
        "pause"
    ],
    "chemotherapy": [
        "drugs to treat cancer"
    ],
    "chest film": [
        "chest X-ray"
    ],
    "cholesterol": [
        "types of fat found in the blood",
        "HDL is good cholesterol",
        "LDL is bad"
    ],
    "HDL cholesterol": [
        "types of fat found in the blood",
        "HDL is good cholesterol",
        "LDL is bad"
    ],
    "LDL cholesterol": [
        "types of fat found in the blood",
        "HDL is good cholesterol",
        "LDL is bad"
    ],
    "chronic": [
        "lasting a long time",
        "life-long"
    ],
    "clavicle": [
        "collarbone"
    ],
    "clinical": [
        "(related to) medical care"
    ],
    "clinical trial": [
        "a research study that tests new treatments on patients"
    ],
    "coagulate": [
        "clot",
        "stop flowing"
    ],
    "cognitive": [
        "learning",
        "thinking"
    ],
    "cognizant": [
        "aware (of)"
    ],
    "coitus": [
        "sex"
    ],
    "collaborate with": [
        "work with"
    ],
    "colon": [
        "large intestine"
    ],
    "colorectal": [
        "large intestine"
    ],
    "colonoscopy": [
        "an exam of the inside of the large intestinethat uses a flexible tube with a lens at the end"
    ],
    "commence": [
        "begin",
        "start"
    ],
    "commitment": [
        "promise"
    ],
    "commonly": [
        "most often"
    ],
    "communicate": [
        "write",
        "tell",
        "talk",
        "let you know"
    ],
    "compensate": [
        "pay",
        "give money"
    ],
    "compensation": [
        "pay",
        "give money"
    ],
    "complete": [
        "finish",
        "do",
        "fill out",
        "take part in"
    ],
    "comply with": [
        "follow"
    ],
    "component": [
        "part",
        "section",
        "phase"
    ],
    "comprise": [
        "form",
        "include",
        "make up"
    ],
    "computed tomography": [
        "CT scan or imaging test",
        "3-D X-ray"
    ],
    "conceal(ed)": [
        "hide (hidden)"
    ],
    "concerning": [
        "about",
        "on"
    ],
    "condition": [
        "how you feel",
        "health problem"
    ],
    "conduct(ing)": [
        "do(ing)"
    ],
    "congenital": [
        "present at birth",
        "born with"
    ],
    "congenital anomaly": [
        "birth defect"
    ],
    "congestive heart failure": [
        "when the heart isn't pumping hard enough"
    ],
    "conjunctivitis": [
        "pink eye"
    ],
    "consequence": [
        "result"
    ],
    "consequently": [
        "so",
        "because of this",
        "as a result"
    ],
    "consider": [
        "think about"
    ],
    "consolidate": [
        "combine",
        "join",
        "put together"
    ],
    "contains": [
        "has"
    ],
    "constitutes": [
        "is",
        "forms",
        "makes up"
    ],
    "construct": [
        "make",
        "build",
        "design"
    ],
    "contingent upon": [
        "if"
    ],
    "continue": [
        "go on",
        "keep (on)"
    ],
    "contraceptive": [
        "birth control"
    ],
    "contract(ing) [a disease]": [
        "get(ing) [a disease]"
    ],
    "contraindicated": [
        "not recommended",
        "can cause a bad reaction",
        "not allowed"
    ],
    "contrast medium": [
        "dye"
    ],
    "contribute": [
        "give",
        "help"
    ],
    "controlled trial": [
        "a study that compares one treatment to another treatment"
    ],
    "contusion": [
        "bruise"
    ],
    "convene": [
        "meet"
    ],
    "convenient": [
        "handy",
        "works well"
    ],
    "conversion": [
        "change"
    ],
    "convulsion": [
        "seizure",
        "shaking"
    ],
    "coronary": [
        "(in/of/related to) the blood vessels that bring blood to the heart"
    ],
    "coronary thrombosis": [
        "heart attack"
    ],
    "correlation": [
        "link"
    ],
    "correspond": [
        "similar to",
        "be in agreement with"
    ],
    "crucial": [
        "very important"
    ],
    "currently": [
        "now"
    ],
    "cutaneous": [
        "(in/of/about/related to) the skin"
    ],
    "debilitating": [
        "weakening"
    ],
    "decision": [
        "choice"
    ],
    "decrease": [
        "lower",
        "reduce"
    ],
    "deem": [
        "think",
        "believe",
        "consider"
    ],
    "deep vein thrombosis": [
        "a blood clot deep in the vein"
    ],
    "deficiency": [
        "not enough"
    ],
    "deficit": [
        "shortage"
    ],
    "degeneration": [
        "getting or gets worse"
    ],
    "delete": [
        "remove",
        "take out",
        "cut",
        "drop"
    ],
    "demonstrate": [
        "prove",
        "show"
    ],
    "depart": [
        "leave"
    ],
    "describing": [
        "tell about"
    ],
    "designate": [
        "choose",
        "name",
        "select",
        "appoint"
    ],
    "detect": [
        "find (out)"
    ],
    "determine": [
        "decide",
        "find (out)",
        "learn (if)"
    ],
    "detrimental": [
        "harmful",
        "bad"
    ],
    "develop": [
        "occur",
        "start to get",
        "happen"
    ],
    "diabetic": [
        "person who has diabetes"
    ],
    "diagnose": [
        "(find the) problem or condition"
    ],
    "diagnosis": [
        "(find the) problem or condition"
    ],
    "diagnostic procedure": [
        "a test to look for a problem"
    ],
    "diaphoresis": [
        "sweating"
    ],
    "difficulties": [
        "problems",
        "trouble"
    ],
    "diffuse": [
        "widespread",
        "scattered"
    ],
    "digit": [
        "finger or toe"
    ],
    "dilute": [
        "add liquid",
        "make less strong"
    ],
    "diminish(ed)": [
        "go down",
        "decrease",
        "less (of)",
        "lower"
    ],
    "disclose": [
        "share",
        "tell",
        "show"
    ],
    "discoloration": [
        "change in color"
    ],
    "disconnect": [
        "unhook",
        "separate",
        "divide"
    ],
    "discontinue": [
        "drop",
        "stop"
    ],
    "discover": [
        "find (out)",
        "learn if"
    ],
    "discrepancy": [
        "conflict",
        "difference",
        "error",
        "split"
    ],
    "disseminate(d)": [
        "give",
        "share",
        "send",
        "pass on",
        "(spread out)"
    ],
    "diuretic": [
        "drug that makes you urinate (OR pee) more"
    ],
    "diverticulitis": [
        "when your large intestine is swollen or  infected"
    ],
    "donate": [
        "give"
    ],
    "double blind": [
        "a study  where the researchers and the participants don't know what drug the participant is getting"
    ],
    "dressing": [
        "bandage"
    ],
    "due to the fact": [
        "because"
    ],
    "dysfunction": [
        "not working"
    ],
    "dysmenorrhea": [
        "painful period cramps"
    ],
    "dyspepsia": [
        "heartburn"
    ],
    "dysphagia": [
        "trouble swallowing"
    ],
    "dyspnea": [
        "trouble breathing"
    ],
    "echocardiography": [
        "pictures of the heart"
    ],
    "echocardiogram": [
        "pictures of the heart"
    ],
    "edema": [
        "swelling"
    ],
    "efficacy": [
        "how well (a treatment) works"
    ],
    "elect": [
        "choose",
        "pick"
    ],
    "electrolytes": [
        "salts in the blood that control the balance of fluids in the body"
    ],
    "elevate": [
        "high",
        "higher",
        "raise"
    ],
    "eliminate": [
        "get rid of",
        "remove",
        "cut",
        "end",
        "go to the bathroom"
    ],
    "elucidate": [
        "explain"
    ],
    "embolism": [
        "lump of blood",
        "clot"
    ],
    "embolist": [
        "clot that blocks a blood vessel or artery"
    ],
    "embolus": [
        "clot that blocks a blood vessel or artery"
    ],
    "emesis": [
        "throwing up",
        "vomiting"
    ],
    "empirical evidence": [
        "proof"
    ],
    "employ": [
        "use"
    ],
    "employment": [
        "work"
    ],
    "enable": [
        "allow",
        "let"
    ],
    "encounter": [
        "meet",
        "meeting"
    ],
    "encourage": [
        "urge"
    ],
    "endeavor": [
        "try"
    ],
    "endometrium": [
        "lining of the uterus"
    ],
    "enlarge": [
        "get bigger"
    ],
    "enroll": [
        "be in",
        "join"
    ],
    "ensue": [
        "follow(ing)",
        "occur after",
        "happen next"
    ],
    "ensure": [
        "make sure"
    ],
    "enumerate": [
        "count"
    ],
    "enuresis": [
        "problems controlling urine",
        "bladder control problems"
    ],
    "epidemiologist": [
        "scientist who studies diseases"
    ],
    "episode": [
        "bout or attack"
    ],
    "equilibrium": [
        "balance"
    ],
    "equivalent": [
        "equal",
        "the same as"
    ],
    "equitable": [
        "fair"
    ],
    "eradicate": [
        "get rid of"
    ],
    "eruption (skin)": [
        "rash or breakout"
    ],
    "especially": [
        "mainly",
        "mostly"
    ],
    "establish": [
        "set up",
        "also",
        "show",
        "prove"
    ],
    "etiology": [
        "cause"
    ],
    "evaluate": [
        "look at",
        "study",
        "measure",
        "rate"
    ],
    "evidence of": [
        "proof of",
        "signs of"
    ],
    "evident": [
        "clear"
    ],
    "exacerbate": [
        "make worse"
    ],
    "examination": [
        "exam"
    ],
    "examine": [
        "look at",
        "study"
    ],
    "excise": [
        "remove by cutting",
        "cut out"
    ],
    "exhale": [
        "breathe out"
    ],
    "exhibit": [
        "show"
    ],
    "expedite": [
        "speed up",
        "make (something) go faster",
        "make (something) easier",
        "(fast",
        "quick)"
    ],
    "expeditious": [
        "speed up",
        "make (something) go faster",
        "make (something) easier",
        "(fast",
        "quick)"
    ],
    "expend": [
        "spend"
    ],
    "experiencing": [
        "feeling",
        "going through",
        "having"
    ],
    "expire": [
        "end (date)",
        "run out"
    ],
    "expiration": [
        "end (date)",
        "run out"
    ],
    "explicit": [
        "plain",
        "clear"
    ],
    "extensive": [
        "A lot (of)",
        "wide-spread",
        "throughout the body"
    ],
    "external": [
        "outside (the body)"
    ],
    "exude": [
        "ooze"
    ],
    "facilitate": [
        "help",
        "ease",
        "make (something) easier"
    ],
    "failed to": [
        "did not"
    ],
    "feasible": [
        "can be done",
        "possible",
        "workable"
    ],
    "febrile": [
        "fever"
    ],
    "femur": [
        "thigh bone",
        "bone that connects the hip and knee"
    ],
    "fetus": [
        "unborn baby"
    ],
    "finalize": [
        "complete",
        "finish"
    ],
    "forfeit": [
        "give up",
        "lose"
    ],
    "formulate": [
        "work out",
        "form",
        "make"
    ],
    "forward": [
        "send"
    ],
    "fracture(d)": [
        "break",
        "(broken)"
    ],
    "frequently": [
        "often",
        "a lot"
    ],
    "fructose": [
        "fruit sugar"
    ],
    "function": [
        "act",
        "role",
        "work"
    ],
    "fundamental": [
        "basic"
    ],
    "furnish": [
        "give",
        "send"
    ],
    "gastric": [
        "(of/in/related to) the stomach"
    ],
    "gastroenterologist": [
        "doctor who treats problems with digestion"
    ],
    "gastroesophageal reflux (GERD=gastroesophageal reflux disease)": [
        "heartburn"
    ],
    "generalized": [
        "wide-spread"
    ],
    "gerontological": [
        "age-related",
        "(related to) aging"
    ],
    "gestation": [
        "pregnancy"
    ],
    "GI specialist": [
        "doctor who treats problems with digestion"
    ],
    "glucose": [
        "sugar"
    ],
    "gradually": [
        "slowly",
        "over time"
    ],
    "gynecologist": [
        "doctor trained in women's health"
    ],
    "hazardous": [
        "dangerous",
        "not safe"
    ],
    "hearing impairment": [
        "hearing loss or deafness"
    ],
    "heart failure": [
        "heart isn't pumping hard enough"
    ],
    "hematocrit": [
        "amount of red blood cells in the blood"
    ],
    "hematoma": [
        "bruise"
    ],
    "hemorrhage": [
        "heavy bleeding"
    ],
    "hence": [
        "so"
    ],
    "hepatic": [
        "(of/in/related to) the liver"
    ],
    "heritable": [
        "genetic",
        "traits that are passed down in families"
    ],
    "hereditary": [
        "genetic",
        "traits that are passed down in families"
    ],
    "herpes simplex type 1": [
        "cold sore"
    ],
    "herpes simplex type 2": [
        "herpes"
    ],
    "herpes zoster": [
        "shingles"
    ],
    "heterogeneous": [
        "different",
        "mixed"
    ],
    "hirsutism": [
        "unwanted hair growth"
    ],
    "homogeneous": [
        "same or similar"
    ],
    "however": [
        "but"
    ],
    "hyperopia": [
        "farsighted(ness)"
    ],
    "hypersensitivity": [
        "very sensitive to"
    ],
    "hypertension": [
        "blood pressure that's too high (blood pressure that's too low)"
    ],
    "hypotension": [
        "blood pressure that's too high (blood pressure that's too low)"
    ],
    "hyperthyroidism": [
        "overactive thyroid",
        "too much thyroid hormone (underactive thyroid",
        "not enough thyroid hormone)"
    ],
    "hypothyroidism": [
        "overactive thyroid",
        "too much thyroid hormone (underactive thyroid",
        "not enough thyroid hormone)"
    ],
    "hypothesis": [
        "idea being tested"
    ],
    "hypoxia": [
        "not enough oxygen in the blood"
    ],
    "identical": [
        "same",
        "exactly alike"
    ],
    "identified": [
        "found"
    ],
    "identify": [
        "find (out)",
        "pinpoint",
        "name",
        "show"
    ],
    "idiopathic": [
        "we don't know what causes it"
    ],
    "immediately": [
        "right away",
        "now",
        "at once"
    ],
    "immerse": [
        "cover in",
        "dip in"
    ],
    "immunotherapy": [
        "treatment to make the immune system work better (boost immune system)"
    ],
    "impact": [
        "change",
        "affect"
    ],
    "impede": [
        "slow",
        "make it harder to"
    ],
    "implant": [
        "put into the body"
    ],
    "implement": [
        "carry out",
        "put in place",
        "start"
    ],
    "impotent": [
        "when a man either can't get or can't keep an erection"
    ],
    "impotence": [
        "when a man either can't get or can't keep an erection"
    ],
    "in addition": [
        "also",
        "too",
        "and"
    ],
    "in vitro": [
        "in a test tube or lab"
    ],
    "incapacitate": [
        "make it hard or impossible to do"
    ],
    "inception": [
        "start",
        "beginning"
    ],
    "incidence": [
        "number of new cases",
        "how many times it occurs"
    ],
    "incision": [
        "cut",
        "slit"
    ],
    "including": [
        "along with",
        "like",
        "such as"
    ],
    "incorrect": [
        "wrong",
        "not right"
    ],
    "increase": [
        "raise",
        "higher"
    ],
    "increased": [
        "raise",
        "higher"
    ],
    "indicate": [
        "mean",
        "show",
        "suggest",
        "tell us",
        "fill in",
        "write down"
    ],
    "indication": [
        "sign",
        "symptom"
    ],
    "ineffectual": [
        "doesn't work",
        "useless",
        "of no use"
    ],
    "infectious": [
        "passed from one person to the next"
    ],
    "infection": [
        "illness",
        "sickness",
        "disease"
    ],
    "infertile": [
        "not able to get pregnant"
    ],
    "inflammation": [
        "swelling",
        "painful swelling"
    ],
    "influence": [
        "affect"
    ],
    "inform": [
        "tell"
    ],
    "informed consent": [
        "deciding to get a certain treatment or be in a research study after thinking about the pros and cons (risks and benefits)"
    ],
    "infusion": [
        "putting a substance into the body through the blood"
    ],
    "ingest": [
        "eat or drink"
    ],
    "inhale": [
        "breathe in"
    ],
    "inhibit": [
        "stop"
    ],
    "inhibitor": [
        "drug that slows down or stops something from happening"
    ],
    "initial": [
        "first"
    ],
    "initiate": [
        "begin",
        "start"
    ],
    "injection": [
        "shot"
    ],
    "in lieu of": [
        "instead (of)"
    ],
    "innovation": [
        "new idea",
        "new way"
    ],
    "inquire": [
        "ask"
    ],
    "institute": [
        "start",
        "set up"
    ],
    "instrument": [
        "tool"
    ],
    "insufficient": [
        "not enough",
        "too little"
    ],
    "intake": [
        "what you eat or drink",
        "what goes into your body"
    ],
    "intent": [
        "aim",
        "goal",
        "purpose"
    ],
    "intention": [
        "aim",
        "goal",
        "purpose"
    ],
    "interface": [
        "meet",
        "work with"
    ],
    "intermittent": [
        "off and on"
    ],
    "internal": [
        "inside (the body)"
    ],
    "interior": [
        "inside"
    ],
    "internist": [
        "doctor of internal medicine"
    ],
    "interrupt": [
        "stop"
    ],
    "intervention": [
        "treatment"
    ],
    "intramuscular": [
        "in a muscle"
    ],
    "intravenous": [
        "in a vein"
    ],
    "intubate": [
        "put a tube down your throat into your airway so you can breathe"
    ],
    "invasive disease": [
        "disease that (can or has) spread to other parts of the body"
    ],
    "invasive procedure": [
        "to go into the body through a cut",
        "slit",
        "or puncture"
    ],
    "investigation": [
        "study"
    ],
    "investigator": [
        "researcher",
        "person doing the study"
    ],
    "investigators": [
        "researchers",
        "people doing the study"
    ],
    "issue": [
        "give"
    ],
    "jaundice": [
        "when the whites of the eyes and the skin look yellow"
    ],
    "juvenile (condition)": [
        "childhood (condition)"
    ],
    "laceration": [
        "cut",
        "tear",
        "slit"
    ],
    "lactation": [
        "breastfeeding"
    ],
    "lactose": [
        "sugar found in milk"
    ],
    "larynx": [
        "voice box"
    ],
    "lateral": [
        "side",
        "on the side"
    ],
    "lethargic": [
        "sluggish",
        "very sleepy"
    ],
    "limb": [
        "arm or leg"
    ],
    "lingual": [
        "tongue"
    ],
    "lipids": [
        "fats in the blood"
    ],
    "lipid profile (or lipid panel)": [
        "lab test to measure the amount of fats in the blood"
    ],
    "locality": [
        "place"
    ],
    "locally": [
        "in one area"
    ],
    "localized": [
        "in one area"
    ],
    "locate": [
        "find"
    ],
    "location": [
        "place"
    ],
    "lymphoma": [
        "cancer of the lymph nodes (or tissues)"
    ],
    "magnetic resonance imaging (MRI)": [
        "pictures of the inside of the body taken with a special machine",
        "like an x-ray but more detailed"
    ],
    "magnitude": [
        "size"
    ],
    "maintain": [
        "keep",
        "support"
    ],
    "malaise": [
        "general feeling of being sick",
        "feeling bad"
    ],
    "malignant": [
        "harmful",
        "poisonous",
        "cancer that may spread to other parts of the body"
    ],
    "malignancy": [
        "harmful",
        "poisonous",
        "cancer that may spread to other parts of the body"
    ],
    "malingering": [
        "pretending to be sick"
    ],
    "majority": [
        "most"
    ],
    "manifestation": [
        "sign"
    ],
    "manner": [
        "way"
    ],
    "materialize": [
        "appear"
    ],
    "maximum": [
        "greatest",
        "largest",
        "most"
    ],
    "mean (statistical)": [
        "average (statistical)"
    ],
    "medication": [
        "drug",
        "medicine"
    ],
    "menarche": [
        "first (menstrual) period"
    ],
    "menopause": [
        "when a woman doesn't get any more (menstrual) periods"
    ],
    "menses": [
        "(menstrual) period"
    ],
    "menstruation": [
        "(menstrual) period"
    ],
    "metabolism": [
        "how the body breaks down food into energy"
    ],
    "metabolize": [
        "how the body breaks down food into energy"
    ],
    "metastasize": [
        "spread"
    ],
    "metastatic": [
        "cancer that has spread"
    ],
    "miliaria": [
        "prickly heat"
    ],
    "minimal": [
        "least",
        "smallest",
        "slight (at least)"
    ],
    "minimum": [
        "least",
        "smallest",
        "slight (at least)"
    ],
    "minimize": [
        "decrease",
        "lower",
        "reduce"
    ],
    "mobile": [
        "able to move around"
    ],
    "mobility": [
        "ability to move around"
    ],
    "moderate (verb)": [
        "limit",
        "control"
    ],
    "modify": [
        "change"
    ],
    "modification": [
        "change"
    ],
    "monitor": [
        "check (on)",
        "keep track (of)",
        "watch"
    ],
    "morbidity": [
        "disease rate",
        "illness rate"
    ],
    "mortality": [
        "death rate",
        "death",
        "dying"
    ],
    "motility": [
        "movement",
        "ability to move"
    ],
    "musculoskeletal": [
        "muscles and bones"
    ],
    "mutation": [
        "genetic defect"
    ],
    "myocardial infarction (MI)": [
        "heart attack"
    ],
    "myopia": [
        "nearsighted(ness)",
        "when it's hard to see things that are far away"
    ],
    "nausea (nauseous)": [
        "upset stomach",
        "feeling like throwing up",
        "feel like vomiting"
    ],
    "nebulous": [
        "vague",
        "not clear"
    ],
    "necessary": [
        "needed",
        "need to"
    ],
    "negligible": [
        "small"
    ],
    "nephropathy": [
        "kidney disease"
    ],
    "neuralgia": [
        "nerve pain"
    ],
    "neuron": [
        "nerve cell"
    ],
    "nodule": [
        "lump"
    ],
    "noncompliant": [
        "not following a treatment plan"
    ],
    "noninvasive": [
        "without using surgery",
        "needles",
        "or cutting the skin"
    ],
    "notification": [
        "to tell",
        "let know"
    ],
    "notify": [
        "to tell",
        "let know"
    ],
    "numerate": [
        "count"
    ],
    "numerous": [
        "many"
    ],
    "nutrient": [
        "food"
    ],
    "objective": [
        "aim",
        "goal"
    ],
    "obligate": [
        "require",
        "bind",
        "means that (you) have to",
        "duty"
    ],
    "obligation": [
        "require",
        "bind",
        "means that (you) have to",
        "duty"
    ],
    "observe": [
        "see"
    ],
    "obstruct": [
        "block or close"
    ],
    "obtain": [
        "get",
        "take"
    ],
    "occasionally": [
        "sometimes"
    ],
    "occlude": [
        "block (blockage)"
    ],
    "occlusion": [
        "block (blockage)"
    ],
    "occupation(al)": [
        "job",
        "work"
    ],
    "oncologist": [
        "doctor who treats cancer"
    ],
    "oncology": [
        "study or treatment of cancer"
    ],
    "onset": [
        "start"
    ],
    "opportunity": [
        "chance"
    ],
    "optimum": [
        "best",
        "greatest",
        "most"
    ],
    "optimal": [
        "best",
        "greatest",
        "most"
    ],
    "option": [
        "choice",
        "way"
    ],
    "oral (oral administration)": [
        "(given) by mouth"
    ],
    "orthopedic": [
        "(of/about/related to) the bones"
    ],
    "osteoporosis": [
        "brittle bone disease",
        "having bones that can break easily"
    ],
    "otherwise": [
        "if not"
    ],
    "otolaryngologist": [
        "ear",
        "nose",
        "and throat doctor"
    ],
    "outcomes": [
        "results",
        "(long-term) changes"
    ],
    "palliative": [
        "make feel better but not cure",
        "ease symptoms"
    ],
    "pallor": [
        "paleness"
    ],
    "palpate": [
        "feel"
    ],
    "palpitation": [
        "fast heartbeat"
    ],
    "parameter": [
        "limit",
        "boundary"
    ],
    "paresthesia": [
        "tingling",
        "prickling",
        "or burning feeling on the skin that can't be explained or doesn't seem to have any cause"
    ],
    "participant": [
        "person who takes part"
    ],
    "participate (ing": [
        "be",
        "do",
        "join",
        "opt in",
        "take part  (ing)"
    ],
    "ion)": [
        "be",
        "do",
        "join",
        "opt in",
        "take part  (ing)"
    ],
    "parturition": [
        "labor and delivery",
        "childbirth"
    ],
    "pathogen(esis)": [
        "cause of a disease"
    ],
    "perforation": [
        "hole"
    ],
    "perform": [
        "do"
    ],
    "periodically": [
        "from time to time"
    ],
    "perioral": [
        "around the mouth"
    ],
    "peripheral": [
        "on the edge",
        "not central"
    ],
    "permit(ted)": [
        "allow(ed)",
        "let"
    ],
    "persist": [
        "last",
        "keep going",
        "doesn't stop"
    ],
    "persistent": [
        "lasting"
    ],
    "personnel": [
        "staff",
        "people"
    ],
    "pertaining to": [
        "about",
        "of",
        "on"
    ],
    "peruse": [
        "read",
        "study",
        "examine with care"
    ],
    "pervasive": [
        "widespread"
    ],
    "pharmaceutical": [
        "drug"
    ],
    "pharmacotherapy": [
        "use drugs to treat a disease or condition"
    ],
    "pharyngitis": [
        "sore throat"
    ],
    "physician": [
        "doctor"
    ],
    "physiological": [
        "having to do with the body"
    ],
    "pigmentation": [
        "color"
    ],
    "placebo": [
        "a pill that doesn't have any drugs or medicine",
        "a \u201csugar\u201d pill"
    ],
    "placenta": [
        "part of the mother's womb that supplies oxygen and nutrition to her unborn baby"
    ],
    "plaque (artery)": [
        "fatty deposit"
    ],
    "plasma": [
        "the fluid part of blood"
    ],
    "plasma glucose": [
        "blood sugar"
    ],
    "portion": [
        "part"
    ],
    "positron emission tomography": [
        "PET scan or imaging test",
        "test done to look at organs in the body"
    ],
    "possess": [
        "have",
        "own"
    ],
    "posterior": [
        "back"
    ],
    "postoperative (post-op)": [
        "after surgery"
    ],
    "preadolescent": [
        "preteen"
    ],
    "preclinical": [
        "isn't causing symptoms yet",
        "no signs yet"
    ],
    "preclude": [
        "prevent",
        "rule out"
    ],
    "predisposed": [
        "likely to",
        "inclined to"
    ],
    "predisposition": [
        "likely to",
        "inclined to"
    ],
    "prenatal": [
        "before birth"
    ],
    "presently": [
        "right now"
    ],
    "present with": [
        "have"
    ],
    "preserve": [
        "keep"
    ],
    "prevalence": [
        "how often it happens",
        "common",
        "happens often"
    ],
    "prevalent": [
        "how often it happens",
        "common",
        "happens often"
    ],
    "prevent": [
        "stop",
        "put a stop to",
        "to keep from happening"
    ],
    "previous": [
        "before",
        "earlier"
    ],
    "previously": [
        "before",
        "earlier"
    ],
    "principal investigator": [
        "head researcher",
        "scientist in charge of a study"
    ],
    "prior (to)": [
        "earlier",
        "before"
    ],
    "prioritize": [
        "rank",
        "order",
        "put in order of importance"
    ],
    "proactive": [
        "taking action on your own"
    ],
    "procedure": [
        "something that is done",
        "a process"
    ],
    "proceed": [
        "do",
        "go ahead",
        "start",
        "try"
    ],
    "procure": [
        "buy",
        "get"
    ],
    "procurement": [
        "buy",
        "get"
    ],
    "proficiency": [
        "skill",
        "skilled"
    ],
    "proficient": [
        "skill",
        "skilled"
    ],
    "prognosis": [
        "outlook"
    ],
    "progress (verb)": [
        "worsen",
        "get(s) worse"
    ],
    "progressive": [
        "worsen",
        "get(s) worse"
    ],
    "prohibit": [
        "prevent",
        "restrict(ive)",
        "strict",
        "may not",
        "don't allow"
    ],
    "prohibitive": [
        "prevent",
        "restrict(ive)",
        "strict",
        "may not",
        "don't allow"
    ],
    "prohibited from": [
        "prevent",
        "restrict(ive)",
        "strict",
        "may not",
        "don't allow"
    ],
    "promulgate": [
        "make",
        "issue",
        "publish"
    ],
    "prone": [
        "lying face down",
        "lying on your stomach"
    ],
    "prophylaxis": [
        "something that prevents disease or infection"
    ],
    "prosthesis": [
        "replacement for a body part",
        "such as a man-made arm"
    ],
    "protocol": [
        "plan of study",
        "rule",
        "process"
    ],
    "provide": [
        "give (us)",
        "offer",
        "say"
    ],
    "provided that": [
        "if"
    ],
    "provider": [
        "doctor",
        "clinician",
        "person who gives health care"
    ],
    "proximal": [
        "close",
        "closer to the center of the body"
    ],
    "psychopathology": [
        "mental illness"
    ],
    "psychosocial": [
        "mental and social"
    ],
    "psychotropic": [
        "mind-altering"
    ],
    "pulmonary": [
        "(in/or/about/related to) the lungs"
    ],
    "pulmonary embolism": [
        "blood clot in the lung"
    ],
    "purchase": [
        "buy"
    ],
    "pursuant to": [
        "by",
        "following",
        "under"
    ],
    "questionnaire": [
        "survey",
        "series of questions"
    ],
    "radiologist": [
        "doctor who specializes in reading X-rays"
    ],
    "radiology": [
        "X-ray department"
    ],
    "ramifications": [
        "outcomes",
        "problems",
        "results"
    ],
    "randomized/randomization": [
        "assigned to a group by chance",
        "like flipping a coin [if there are 2 groups]...like drawing names out of a hat [if there are more than 2 groups]"
    ],
    "random(ly)": [
        "by chance"
    ],
    "random sample": [
        "group of (people) chosen by chance",
        "like drawing names out of a hat"
    ],
    "range": [
        "area",
        "between (x) and (y)",
        "from low(est) to high(est)"
    ],
    "receive": [
        "get"
    ],
    "recur": [
        "return",
        "come back",
        "happen again"
    ],
    "referral": [
        "send to see another doctor"
    ],
    "reflect": [
        "say",
        "show"
    ],
    "reflux": [
        "heartburn"
    ],
    "refractory": [
        "hard to treat",
        "hard to manage"
    ],
    "regarding": [
        "about",
        "of",
        "on"
    ],
    "regardless": [
        "no matter"
    ],
    "regimen": [
        "treatment plan"
    ],
    "regulate": [
        "affect",
        "control"
    ],
    "regulations": [
        "rules"
    ],
    "relapse": [
        "slip",
        "backslide",
        "return of a disease"
    ],
    "relevant (to)": [
        "about",
        "tied in with",
        "related to"
    ],
    "relocate": [
        "move"
    ],
    "remain": [
        "stay",
        "wait"
    ],
    "remainder": [
        "rest",
        "what is left over"
    ],
    "remaining": [
        "other",
        "(second",
        "last",
        "final)",
        "left",
        "left over"
    ],
    "remission": [
        "cancer that has gone away"
    ],
    "renal": [
        "(in/of/about/related to) the kidneys"
    ],
    "render": [
        "make",
        "give"
    ],
    "replicable": [
        "can be done again"
    ],
    "represents": [
        "is"
    ],
    "request": [
        "ask"
    ],
    "require(d)": [
        "must do or have",
        "need(ed)"
    ],
    "requirement": [
        "must do or have",
        "need(ed)"
    ],
    "researchers": [
        "people doing the study"
    ],
    "resect": [
        "cut out",
        "take out through surgery",
        "remove"
    ],
    "reside": [
        "live",
        "house",
        "home"
    ],
    "residence": [
        "live",
        "house",
        "home"
    ],
    "respiration": [
        "breathing"
    ],
    "restrictions": [
        "limits"
    ],
    "retain": [
        "keep"
    ],
    "retinol": [
        "vitamin A"
    ],
    "retrospective study": [
        "a study looking at things that have already happened"
    ],
    "revise(d)": [
        "change(d)",
        "new"
    ],
    "revision": [
        "change(d)",
        "new"
    ],
    "reveal": [
        "give us",
        "show",
        "tell"
    ],
    "routinely": [
        "often",
        "commonly"
    ],
    "rupture": [
        "break open",
        "burst"
    ],
    "sarcoma": [
        "type of cancer"
    ],
    "satisfactory": [
        "okay",
        "fine",
        "good"
    ],
    "sclerosis": [
        "when certain tissues of the body get hard and thick"
    ],
    "sedative": [
        "a drug to make you feel calm or less anxious"
    ],
    "sedentary": [
        "inactive",
        "not active"
    ],
    "seldom": [
        "rarely",
        "not very often"
    ],
    "selection": [
        "choice"
    ],
    "sensation": [
        "feeling"
    ],
    "sepsis": [
        "a very serious infection"
    ],
    "sequentially": [
        "in a row",
        "in order",
        "by number"
    ],
    "several": [
        "a few",
        "a number of",
        "some"
    ],
    "severe": [
        "serious",
        "bad"
    ],
    "severity": [
        "how bad"
    ],
    "shall": [
        "will"
    ],
    "similar (to)": [
        "like",
        "alike"
    ],
    "similarity": [
        "likeness"
    ],
    "sinusitis": [
        "sinus infection"
    ],
    "solely": [
        "only"
    ],
    "solicit": [
        "ask for",
        "request"
    ],
    "somnolence": [
        "sleepiness"
    ],
    "specify": [
        "name"
    ],
    "specimen": [
        "sample"
    ],
    "spirometer": [
        "a device that measures how much air you're breathing in and out"
    ],
    "state-of-the-art": [
        "latest"
    ],
    "stenosis": [
        "getting more narrow"
    ],
    "stimulate": [
        "excite",
        "trigger"
    ],
    "strategy": [
        "(make a) plan"
    ],
    "strategize": [
        "(make a) plan"
    ],
    "streptococcal": [
        "strep"
    ],
    "subcutaneous": [
        "under the skin"
    ],
    "sublingual": [
        "medication taken by dissolving under the tongue",
        "under the tongue"
    ],
    "submit": [
        "give",
        "send"
    ],
    "subsequent(ly)": [
        "after",
        "later",
        "next",
        "then"
    ],
    "substantial": [
        "big",
        "large",
        "much"
    ],
    "sucrose": [
        "sugar"
    ],
    "sufficient": [
        "enough",
        "plenty"
    ],
    "suggest(s)": [
        "show(s) there might be"
    ],
    "supine": [
        "lying on your back"
    ],
    "sustain": [
        "keep going"
    ],
    "sustenance": [
        "support",
        "food"
    ],
    "sutures": [
        "stitches"
    ],
    "symptomatic": [
        "having symptoms"
    ],
    "systemic": [
        "whole body"
    ],
    "tachycardia": [
        "very fast heart beat"
    ],
    "tap": [
        "use a needle to take out fluid"
    ],
    "tear a ligament (torn ligament)": [
        "sprain"
    ],
    "telephone": [
        "phone"
    ],
    "terminal": [
        "not curable",
        "causes death",
        "going to die"
    ],
    "terminate": [
        "put an end to",
        "stop",
        "end"
    ],
    "termination": [
        "put an end to",
        "stop",
        "end"
    ],
    "therapeutic modality": [
        "treatment"
    ],
    "therapy": [
        "treatment"
    ],
    "therefore": [
        "so",
        "as a result"
    ],
    "thoracic": [
        "chest"
    ],
    "thrombosis": [
        "blood clots in the blood vessels"
    ],
    "topical (application)": [
        "surface",
        "on the skin",
        "(put on",
        "put on the skin)"
    ],
    "torso": [
        "trunk",
        "main part of your body not including head",
        "arms",
        "or legs"
    ],
    "toxic": [
        "poisonous",
        "poison"
    ],
    "toxin": [
        "poisonous",
        "poison"
    ],
    "toxicity": [
        "bad side effects"
    ],
    "trachea": [
        "windpipe"
    ],
    "transdermal": [
        "through the skin"
    ],
    "transmit(ted)": [
        "send (sent)",
        "spread to",
        "pass on"
    ],
    "transmission": [
        "send (sent)",
        "spread to",
        "pass on"
    ],
    "transpire": [
        "happen"
    ],
    "trauma": [
        "injury",
        "wound"
    ],
    "tremor": [
        "shaking"
    ],
    "ultimate": [
        "final"
    ],
    "uncommon": [
        "rare"
    ],
    "undergo": [
        "have"
    ],
    "understand": [
        "learn",
        "see"
    ],
    "unequivocal": [
        "clear"
    ],
    "unnecessary": [
        "not needed"
    ],
    "urinalysis": [
        "urine test"
    ],
    "utilize": [
        "use"
    ],
    "utilization": [
        "use"
    ],
    "validate": [
        "approve",
        "confirm"
    ],
    "variable": [
        "factor",
        "changes over time"
    ],
    "varicella": [
        "chickenpox"
    ],
    "variety": [
        "many different kinds"
    ],
    "vector": [
        "an insect or other animal that carries disease"
    ],
    "vertigo": [
        "dizziness"
    ],
    "viable": [
        "practical",
        "workable",
        "possible"
    ],
    "visualize": [
        "picture",
        "see",
        "imagine"
    ],
    "vitals": [
        "heart rate",
        "blood pressure",
        "breathing rate",
        "and temperature"
    ],
    "vital signs": [
        "heart rate",
        "blood pressure",
        "breathing rate",
        "and temperature"
    ],
    "warrant": [
        "call for",
        "permit"
    ],
    "whereas": [
        "because",
        "since"
    ],
    "withdraw (from)": [
        "drop",
        "leave",
        "take back",
        "take out"
    ]
};

export { prismWords };